import { createComponent, ElementWithProps } from '@carvana/merch-components';
import cx from 'classnames';
import SubSections from '~/constants/vdp/subSections';

// Scroll top to account for the sticky banner height on mobile
export const scrollTopClasses =
  'scroll-mt-[var(--sticky-banner-height)] sm:scroll-mt-[var(--scroll-top-sm,0px)] md:scroll-mt-[var(--scroll-top-md,0px)]';

export const SectionHeader = createComponent('h2', {
  className: cx(
    'flex flex-col overflow-hidden',
    'text-ellipsis text-center text-text-strong t-heading-xl md:t-heading-2xl',
    'before:mx-auto before:mb-md before:block before:h-sm before:w-2xl before:rounded-[1.5px] before:bg-decorative-2-strong'
  )
});

export const SubHeader = createComponent('h3', {
  className: 'overflow-hidden text-ellipsis text-text-strong t-heading-lg'
});

export const SubSection = createComponent<
  ElementWithProps<{ id: SubSections }>
>('div', props => ({
  ...props,
  className: scrollTopClasses
}));

export const Text = createComponent('div', {
  className: 'text-text-default t-body-sm'
});
